import React, { useEffect, useState } from 'react'
import './Marcas.scss'

const CAROUSEL_ENDPOINT =
	'https://catalogo.autopartesdelsur.com.ar/api/config/carrusel/?'

const MarcasGrid = () => {
	const [brands, setBrands] = useState([])

	useEffect(() => {
		let isMounted = true

		const fetchBrands = async () => {
			try {
				const response = await fetch(CAROUSEL_ENDPOINT)

				if (!response.ok) {
					throw new Error('Error al obtener el carrusel')
				}

				const payload = await response.json()
				const carouselItems = Array.isArray(payload?.data?.carousel)
					? payload.data.carousel
					: []

				const fetchedBrands = carouselItems
					.filter((item) => item?.src)
					.slice()
					.sort((a, b) => (a.Order ?? 0) - (b.Order ?? 0))
					.map((item) => {
						const filename = item.src.split('/').pop() ?? ''
						const cleanedName =
							filename
								.replace(/\.[^/.]+$/, '')
								.replace(/[-_]+/g, ' ')
								.trim() || 'Marca'

						return {
							id: item.Order ?? item.src,
							src: item.src,
							alt: cleanedName
						}
					})

				if (isMounted) {
					setBrands(fetchedBrands)
				}
			} catch (error) {
				console.error('No se pudieron cargar las marcas', error)
			}
		}

		fetchBrands()

		return () => {
			isMounted = false
		}
	}, [])

	return (
		<div className="container marcas-grid-container">
			<div className="row">
				<div className="col-12">
					<div className="marcas-grid">
						{brands.map((brand) => (
							<div className="marcas-grid__item" key={brand.id}>
								<img src={brand.src} alt={brand.alt} loading="lazy" />
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	)
}

export default MarcasGrid
